module.exports = __webpack_public_path__ + "img/Yuu_top.28bb45c3.png";